import React, { useCallback } from 'react';
import { Image } from '@common-fe/common-fe';

import { Document } from '@/common/types';
import { useLockboxDividingModeStore } from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDividingMode.store';

const useAddImageBlobToGroups = () => {
  const { groups, updatedItemsSet, updateItemById } = useLockboxDividingModeStore();

  const renderGroupImage = useCallback((index: number, document: Document, content: React.ReactNode) => {
    const pageNumber = `${index + 1}`;

    if (updatedItemsSet.has(pageNumber)) {
      return content;
    }

    const group = groups?.find((group) => group?.items?.find((item) => item?.key === pageNumber));

    if (group) {
      updateItemById(group?.key || '', pageNumber, {
        key: pageNumber,
        node: (
          <Image
            key={pageNumber}
            src={document.blob}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
          />
        )
      });  
    }

    return content;
  }, [groups, updatedItemsSet, updateItemById]);

  return {
    renderGroupImage
  };
};

export default useAddImageBlobToGroups;
